import { z } from 'zod';
import { SPACE_ROLES } from '../permissions.js';
import { colorSchema, emailSchema, slugSchema } from './common.js';
export const spaceRoleSchema = z.enum(SPACE_ROLES);
export const createSpaceSchema = z.object({
    name: z.string().trim().min(1).max(160),
    color: colorSchema.optional(),
});
export const updateSpaceSchema = z
    .object({
    name: z.string().trim().min(1).max(160),
    slug: slugSchema,
    description: z.string().trim().max(300),
    color: colorSchema,
    /** Пересоздать адрес из нового названия (онбординг переименовывает «Мой спейс»). */
    slugFromName: z.boolean(),
})
    .partial();
export const deleteSpaceSchema = z.object({ confirmName: z.string().trim().min(1).max(160) });
export const updateMemberSchema = z.object({
    role: spaceRoleSchema.exclude(['owner']),
    managePrivate: z.boolean().optional(),
});
export const createInvitationSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('email'), email: emailSchema, role: spaceRoleSchema.exclude(['owner']) }),
    z.object({ kind: z.literal('link'), role: spaceRoleSchema.exclude(['owner']) }),
]);
//# sourceMappingURL=spaces.js.map